import React from "react";
import type { Control, FieldValues, UseControllerProps } from "react-hook-form";
import { useController } from "react-hook-form";

import type { NumberInputProps } from "@braintrust/braintrust-ui-components";
import { DollarInput } from "@braintrust/braintrust-ui-components";

export type RhfDollarNumberFieldProps<T extends FieldValues> =
  UseControllerProps<T> &
    NumberInputProps & {
      control: Control<T>;
      hideError?: boolean;
    };

export const RhfDollarNumberField = <T extends FieldValues>({
  helperText,
  hideError,
  ...props
}: RhfDollarNumberFieldProps<T>) => {
  const { field, fieldState } = useController(props);

  return (
    <DollarInput
      {...props}
      {...field}
      onChange={(value) => {
        props.onChange?.(value);
        if (value === "") {
          // set to default value to avoid `dirty` state
          field.onChange(undefined);
        } else {
          field.onChange(value);
        }
      }}
      ref={undefined}
      error={fieldState.invalid}
      helperText={
        !hideError && fieldState.error?.message
          ? fieldState.error?.message
          : helperText
      }
    />
  );
};
